/**
 * The Отчеты tab set, in the Figma left→right order. Each value is a URL param
 * value (owned by the route) and an i18n key under `reports.tabs.<value>`.
 */
export const DELIVERY_REPORT_TABS = [
  'branchSales',
  'operational',
  'deliveryLog',
] as const;

export type DeliveryReportTab = (typeof DELIVERY_REPORT_TABS)[number];

/** The default tab when the URL omits one. */
export const DEFAULT_REPORT_TAB: DeliveryReportTab = 'branchSales';
